<script setup lang="ts">
import { useScreenSize } from '../../../utils/useScreenSize';
import AsyncImage from './AsyncImage.vue';
import IconComponent from '../common/IconComponent.vue'

const { isMobile } = useScreenSize();

const props = withDefaults(defineProps<{
  icon?: string | null
  caption: string
  className?: string
  iconColor?: string
  disabled?: boolean
  darkBgColor?: string
  bgColor?: string
  darkTextColor?: string
  textColor?: string
  image?: string
  name?: string
  displayText?: boolean
  type?: 'primary' | 'warning' | 'danger' | 'success' | 'info' | 'secondary'
}>(), {
  darkBgColor: 'dark:bg-gray-700 dark:hover:bg-gray-600',
  bgColor: 'bg-gray-100 hover:bg-gray-200',
  darkTextColor: 'dark:text-gray-200',
  textColor: 'text-gray-700',
  displayText: false,
})

defineEmits<{
  (e: 'click'): void
}>()

const getColor = (variant: string) => {
  switch (variant) {
    case "danger":
      return "text-red-600 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-100";
    case "primary":
    return "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-100";
    case "info":
      return "text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-100";
    case "secondary":
      return "text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-100";
    case "success":
      return "text-green-600 dark:text-green-400 hover:bg-green-100 dark:hover:bg-green-100";
    case "warning":
      return "text-yellow-600 dark:text-yellow-400 hover:bg-yellow-100 dark:hover:bg-yellow-100";
    default:
      return props.bgColor + ' ' + props.darkBgColor + ' ' + props.textColor + ' ' + props.darkTextColor;
  }
}

</script>
<template>
    <button
      :id="name"
      @click="$emit('click')"
      :disabled="props.disabled"
      logLevel="informative"
      class="px-1 py-1 flex items-center text-sm font-medium rounded "
      :class="className, getColor(props.type ?? '')" 
      :style="{height: isMobile ? '48px' : '', padding: isMobile ? '5px' : '',         
        cursor:
                props.disabled
                  ? 'not-allowed'
                  : 'pointer',
      }"
    >
      <AsyncImage className="w-[40px] mr-1" v-if="props.image" :src="props.image" :alt="props.caption" />
      <IconComponent v-if="props.icon" :name="props.icon" class="mr-1" :color="props.iconColor" :width="20" :height="20" />       
      <span v-if="!isMobile || displayText">{{ props.caption }}</span>
    </button>
</template>